import type Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import type EventReservation from '../../schema/EventReservation';
import assignPlace from './assignPlace';
import getSeatsReserved from './getSeatsReserved';
import setReservationEntityData from './setReservationEntityData';

/**
 * parse data for Event Reservation
 */
export default function setEventEntityData(entity: Entity, eventEntity: any): EventReservation {
    if (entity && eventEntity) {
        if (isEventEntityValid(eventEntity)) {
            let newEventEntity: EventReservation = setReservationEntityData(
                entity,
                eventEntity,
                true /* isReservationIdRequired */
            );
            let reservationFor = eventEntity.reservationFor;

            if (reservationFor) {
                newEventEntity = {
                    ...newEventEntity,
                    ...{
                        entityName: EntityTypeNames.EventReservation,
                        entityType: EntityType.EventReservation,
                        name: eventEntity.underName.name,
                        startDate: reservationFor.startDate,
                        startDateUtc: reservationFor['startDate/utc'],
                        endDate: reservationFor.endDate,
                        endDateUtc: reservationFor['endDate/utc'],
                        numSeats: getSeatsReserved(eventEntity),
                        location: assignPlace(newEventEntity, reservationFor.location),
                        eventName: reservationFor.name,
                    },
                };
                return newEventEntity;
            }
        }
    }
    return null;
}

function isEventEntityValid(eventEntity: any) {
    if (
        eventEntity?.reservationFor?.startDate &&
        eventEntity.underName &&
        eventEntity.underName.name
    ) {
        return true;
    }
    return false;
}
